import React from 'react';
import BackArrow from '../../../static/dashboard/backarrow.svg';

export default function SettingsSubscriptionCancelled({ history }) {
    return (
        <div className="SettingsSubscriptionCancelled center-dashboard-content">
            <img 
            className="back-arrow"
            src={BackArrow} 
            alt="Go Back"
            onClick={(e) => history.push('/dashboard/settings/billing')}/>
            <div className="header text-center">
                <h1>Subscription Cancelled!</h1>
                <p>Sad to see you go. If you change your mind you can start another subscription.</p>
            </div>
        </div>
    )
}